import styled, {ThemeProps} from 'styled-components';

// COLOR Palette
import {defaultTheme, headingSizes} from '@stencil/build-theme';

// THEME
import {Theme} from '@stencil/build-theme/src/types';

export const PolicyStyledWrapper = styled.div(
  props => `

  width: 100%;
  margin: 2.5rem auto 0;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const PolicyHeaderStyled = styled.div(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
  display: flex;
  align-items: center;
`,
);

export const PolicyHeaderTextStyled = styled.h2`
  ${headingSizes.Base}
  margin-right: 16px;
`;

export const TimingPolicyWrapper = styled.p(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(16)};
  background: #EEF4FD;
  border-radius: 53px;
  padding: 9px 16px;
  display: flex;
  align-items: center;

   > span:first-child {
    margin-right: 22px;
   }
  `,
);

export const PolicyListItemTextStyled = styled.li(
  (props: ThemeProps<Theme>) => `
  display: flex;
  font-size: ${props.theme.font.custom(16)};
  padding: ${props.padding || '0 2.5rem 0.5rem'};
  align-items: flex-start;
  list-style-type: none;
  // max-width: 50%;
`,
);

export const ErrorText = styled(PolicyListItemTextStyled)(
  props => `
  color: ${props.theme.colors.goRed.base};
  padding: ${props.theme.spacing.xlarge};
`,
);

export const staticCheckedIconProps = {
  height: '1.5rem',
  width: '1.5rem',
  fill: defaultTheme.colors.downriver.dark,
};

export const CheckedIconWrapperStyled = styled.span(
  props => `
  padding: 0.2rem ${props.theme.spacing.large} 0 0;
`,
);

export const PolicyTextStyled = styled.span`
  /* margin-top: -4px; * to make for font deformalities - https://www.youtube.com/watch?v=jnV1u67_yVg */
`;
export const PolicyLoaderTextCenter = styled.p(
  props => `
    text-align: center;
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2.5rem 0;
    padding-bottom: calc(1.6rem + 10px);
  `,
);
